var _path, _a;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1348 3.32812C14.1348 3.47461 14.1348 3.5918 14.1348 3.73828C14.1348 7.81055 11.0586 12.4688 5.4043 12.4688C3.64648 12.4688 2.03516 11.9707 0.6875 11.0918C0.921875 11.1211 1.15625 11.1504 1.41992 11.1504C2.85547 11.1504 4.17383 10.6523 5.22852 9.83203C3.88086 9.80273 2.73828 8.92383 2.35742 7.69336C2.5625 7.72266 2.73828 7.75195 2.94336 7.75195C3.20703 7.75195 3.5 7.69336 3.73438 7.63477C2.32812 7.3418 1.27344 6.11133 1.27344 4.61719V4.58789C1.68359 4.82227 2.18164 4.93945 2.67969 4.96875C1.83008 4.41211 1.30273 3.47461 1.30273 2.41992C1.30273 1.83398 1.44922 1.30664 1.71289 0.867188C3.23633 2.71289 5.52148 3.94336 8.07031 4.08984C8.01172 3.85547 7.98242 3.62109 7.98242 3.38672C7.98242 1.6875 9.35938 0.310547 11.0586 0.310547C11.9375 0.310547 12.7285 0.662109 13.3145 1.27734C13.9883 1.13086 14.6621 0.867188 15.248 0.515625C15.0137 1.24805 14.5449 1.83398 13.9004 2.21484C14.5156 2.15625 15.1309 1.98047 15.6582 1.74609C15.248 2.36133 14.7207 2.88867 14.1348 3.32812Z",
    fill: "#050B20"
  })), _a || (_a = /*#__PURE__*/React.createElement("a", {
    href: "https://www.figma.com/design/PzQUNVEIeMrv8HjdXbjYra?node-id=13-779"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillOpacity: 0,
    x: 0.1875,
    y: -1.125,
    width: 15,
    height: 17.25
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.0d80a7adb0d4cf4985b7a9d45b57e2f3.svg";
export { ForwardRef as ReactComponent };